import{z as o}from"zod";const r=o.object({refresh_token:o.string()}),t=r.partial();export{t as OptionalRefreshTokenInput,r as RefreshTokenInput};
